export class VisitStore {
    visitStoreNode: HTMLElement | null = document.querySelector('a[href="#visitStore"]');
    visitStoreWindowNode: HTMLElement | null = document.querySelector('.js-visit-store-window');
    siteOverlayNode: HTMLElement | null = document.querySelector('.js-site-overlay');

    constructor() {
        if (!this.visitStoreNode || !this.visitStoreWindowNode || !this.siteOverlayNode) {
            return;
        }

        this.visitStoreNode.addEventListener('click', (e: Event) => {
            e.preventDefault();
            this.toggleVisibility();
        });

        document.addEventListener('click', (e: Event) => {
            const target = e.target as Node;
            if (
                this.visitStoreWindowNode &&
                !this.visitStoreWindowNode.contains(target) &&
                !this.visitStoreNode?.contains(target)
            ) {
                this.hideVisitStore();
            }
        });
    }

    private toggleVisibility = () => {
        if (this.visitStoreWindowNode?.classList.contains('visible')) {
            this.hideVisitStore();
        } else {
            this.showVisitStore();
        }
    };

    private showVisitStore = () => {
        this.visitStoreWindowNode?.classList.add('visible', 'opacity-100');
        this.siteOverlayNode?.classList.add('visible', 'opacity-100');
    };

    private hideVisitStore = () => {
        this.visitStoreWindowNode?.classList.remove('visible', 'opacity-100');
        this.siteOverlayNode?.classList.remove('visible', 'opacity-100');
    };
}